@if (state$ | async; as state) {
  <!-- one card per export, oldest at the top, newest at the bottom; the tray is gone when empty -->
  @if (state.exports.length) {
    <div class="export-tray">
      @for (entry of state.exports; track entry.id) {
        <div class="card export-card" [class.closing]="entry.closing">
          @switch (entry.status) {
            @case ('running') {
              <div class="export-spinner"></div>
              <div class="export-text">
                <div class="export-title">Przygotowuję plik…</div>
                <div class="export-detail text-mono">{{ rangeLabel(entry) }}</div>
              </div>
            }
            @case ('ready') {
              <div class="export-text">
                <div class="export-title">Plik gotowy</div>
                <div class="export-detail text-mono" [title]="entry.fileName">{{ entry.fileName }}</div>
              </div>
              <button class="btn" type="button" (click)="download(entry)">Pobierz</button>
              <button class="btn-icon" type="button" title="Zamknij" (click)="dismiss(entry)">×</button>
            }
            @case ('failed') {
              <div class="export-text">
                <div class="export-title export-title-failed">Nie udało się przygotować pliku</div>
                <div class="export-detail text-mono">{{ rangeLabel(entry) }}</div>
              </div>
              <button class="btn" type="button" (click)="retry(entry)">Spróbuj ponownie</button>
              <button class="btn-icon" type="button" title="Zamknij" (click)="dismiss(entry)">×</button>
            }
          }
        </div>
      }
    </div>
  }
}
